import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DonationType } from '../../../types/donation-flow.models';

export interface DonationSummaryVM {
  donationType: DonationType;
  currency: string; // p.ej. 'USD'
  amount: number; // monto base (unidades mayores)
  fees: number; // en unidades mayores
  feesCovered: boolean;
  total: number; // amount + fees (si feesCovered), en unidades mayores
  campaignName?: string | null;
  donorName?: string | null;
  donorEmail?: string | null;
}

@Component({
    selector: 'donation-summary-card',
    imports: [CommonModule, TranslateModule],
    templateUrl: './donation-summary-card.component.html',
    styleUrls: ['./donation-summary-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DonationSummaryCardComponent {
  @Input() summary: DonationSummaryVM | null = null;
}
